"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarRoutePopup = CarRoutePopup;
var _DirectionsCar2 = _interopRequireDefault(require("@mui/icons-material/DirectionsCar"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CarRoutePopup(_ref) {
  let {
    theme
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DirectionsCar2.default, {
    fontSize: "large"
  })));
}